import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject} from 'rxjs/Subject';
import { SearchService } from './../../services/search.service';

// keyboard events
const KEY_DW = 40;
const KEY_RT = 39;
const KEY_UP = 38;
const KEY_LF = 37;
const KEY_ES = 27;
const KEY_EN = 13;
const KEY_TAB = 9;
const KEY_BK = 8;
const KEY_SH = 16;
const KEY_CL = 20;
const KEY_F1 = 112;
const KEY_F12 = 123;

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  providers:[SearchService],
  encapsulation: ViewEncapsulation.None
})
export class SearchComponent implements OnInit {
  @Input() source: string;
  @Input() query: string;
  @Input() label: string;
  @Input() searchText: string;

  @Output() onSelectResult = new EventEmitter();

  results:any = [];
  searchTerm = new Subject<string>();
  //searchText: string = "";

  _loadingText: string = "Searching...";
  _noResultsText: string = "No results found";

  searchInitialized: boolean = false;
  searching: boolean = false;
  displaySearching: boolean = true;
  displayNoResults: boolean = true;

  constructor(private searchService:SearchService) { }

  ngOnInit() {
    this.searchService.search(this.searchTerm, this.source, this.query)
    .subscribe(results => {
      this.searching = false;
      this.results = results;
      console.log('results: ',this.results);
    });
  }

  onResultItemClick(result: any){
    this.searchText = typeof( result.name) == 'string'? result.name:result.numberplate;
    this.searchInitialized = false;
    this.onSelectResult.emit(result);
  }

  onKeyup(event: any) {
    var key = event.keyCode;
    if ( key === KEY_LF || key === KEY_RT || key === KEY_DW || key === KEY_UP || key === KEY_TAB || key === KEY_EN) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }
    if (key !== 0 && key !== KEY_SH && key !== KEY_CL && (key <= KEY_F1 || key >= KEY_F12) && !event.ctrlKey && !event.metaKey && !event.altKey) {
      var val = event.target.value;
      this.results = [];
      if(val.length >= 3){
        this.searchInitialized = true;
        this.searching = true;
        this.searchTerm.next(val);
      } else {
        this.searchInitialized = false;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/search/search.component.ts